import React, { Component } from 'react';
import classNames from 'classnames';

class Content extends Component {
  render () {
    const classes = classNames(this.props.className, 'be-content');
    return (
      <div className={classes}>
        {this.props.children}
      </div>
    );
  }
}

export default Content;
